import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import uniqBy from 'lodash/uniqBy';
import { put, select, takeLatest } from 'redux-saga/effects';
import { DocumentsAPI } from 'api/document/document-core';
import { selectActiveDocumentInfo, selectTaskSectionIdNameMap, setTaskSectionNameIdMap, updateDocTaskIdNameMap, selectDocumentResourceSections, ResourceSectionType } from 'data/documents';
function* updateDocTaskIdNameMapManager(action) {
    const { payload } = action;
    try {
        var _payload_resourceObjects, _ref;
        const documentResources = yield select(selectDocumentResourceSections);
        const currentMap = yield select(selectTaskSectionIdNameMap);
        const { publicSection } = yield select(selectActiveDocumentInfo);
        const currentMapArray = Object.keys(currentMap).reduce((acc, id)=>{
            var _currentMap_id;
            if (((_currentMap_id = currentMap[id]) === null || _currentMap_id === void 0 ? void 0 : _currentMap_id.parentDoc) === payload.documentId) {
                var _ref;
                var _currentMap_id1, _currentMap_id2;
                acc.push({
                    resourceSectionId: parseInt(id, 10),
                    resourceSectionName: (_currentMap_id1 = currentMap[id]) === null || _currentMap_id1 === void 0 ? void 0 : _currentMap_id1.content,
                    resourceObjects: (_ref = (_currentMap_id2 = currentMap[id]) === null || _currentMap_id2 === void 0 ? void 0 : _currentMap_id2.resourceObjects) !== null && _ref !== void 0 ? _ref : [],
                    resourceSectionType: ResourceSectionType.DocumentTask
                });
            }
            return acc;
        }, []);
        const currentSection = currentMapArray.find((section)=>section.resourceSectionId === payload.resourceSectionId);
        const uniqMap = uniqBy([
            {
                resourceSectionId: payload.resourceSectionId,
                resourceSectionName: payload.resourceSectionName || (currentSection === null || currentSection === void 0 ? void 0 : currentSection.resourceSectionName),
                resourceSectionType: ResourceSectionType.DocumentTask,
                resourceObjects: uniqBy([
                    ...(_payload_resourceObjects = payload.resourceObjects) !== null && _payload_resourceObjects !== void 0 ? _payload_resourceObjects : [],
                    ...payload.isReplaceExisting ? [] : (_ref = currentSection === null || currentSection === void 0 ? void 0 : currentSection.resourceObjects) !== null && _ref !== void 0 ? _ref : []
                ], 'taskId')
            },
            ...currentMapArray,
            ...documentResources
        ], 'resourceSectionId');
        const response = yield DocumentsAPI.updateDocumentTaskSectionsMeta(payload.projectId, payload.documentId, publicSection, uniqMap);
        const resourceSections = get(response.sections.find((section)=>section.documentSectionId === publicSection.id), [
            'meta',
            'resourceSections'
        ], []);
        const updatedMap = resourceSections.reduce((acc, item)=>{
            if (item.resourceSectionId && (item === null || item === void 0 ? void 0 : item.resourceSectionType) === ResourceSectionType.DocumentTask // we should put only the doc sections in the idMap, not the status update resource sections
            ) {
                acc[item.resourceSectionId] = {
                    content: item.resourceSectionName,
                    parentDoc: payload.documentId,
                    resourceSectionType: ResourceSectionType.DocumentTask,
                    resourceObjects: item.resourceObjects
                };
            }
            return acc;
        }, {});
        if (!isEmpty(updatedMap)) {
            yield put(setTaskSectionNameIdMap(updatedMap));
        }
    } catch (unused) {
    // TODO
    }
}
export const watchUpdateDocTaskIdNameMap = function*() {
    yield takeLatest(updateDocTaskIdNameMap.type, updateDocTaskIdNameMapManager);
};
